import { createCaseSteps } from "../CaseFormFields";

export default function CaseCreateHeaderMobile({ step }) {
  const pct = Math.round(((step - 1) / 4) * 100);

  return (
    <div className="font-plexsans">
      <div className="bg-navy px-[18px] pt-4 pb-3.5">
        <div className="text-[10px] font-medium text-gold tracking-[.1em] uppercase mb-1.5 font-plexmono">
          Step {step} of 5
        </div>
        <div className="h-[5px] bg-[rgba(247,244,237,.15)] rounded-full overflow-hidden">
          <div
            className="h-full bg-gold transition-all duration-300"
            style={{ width: `${step === 5 ? 100 : pct}%` }}
          />
        </div>
      </div>

      <div className="px-[18px] pt-[22px] pb-1 bg-ivory">
        <h2 className="font-spectral font-normal text-[22px] leading-[1.3] text-navy mb-1.5">
          {createCaseSteps[step - 1].title}
        </h2>
        <p className="text-sm leading-relaxed text-[rgba(20,33,61,.55)] mb-0">
          {createCaseSteps[step - 1].subtitle}
        </p>
      </div>
    </div>
  );
}
